import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { connect } from "react-redux";
import { property } from "lodash";
import Link from "jl-design-system/elements/link/Link";
import Icon from "../icon/Icon";
import styles from "./navigation.scss";
import routeConstants from "../../constants/routeConstants";
import Breadcrumb from "../breadcrumb/Breadcrumb";
import MY_PARTNERSHIP from "../../views/my-jl/myJLConstants";
import { ENV_VARS } from "../../../config";

const getItems = (loyaltyScheme) =>
  [
    {
      text: "Account overview",
      path: `${ENV_VARS.REACT_APP_MY_ACCOUNT_HOST}${routeConstants.ACCOUNT_OVERVIEW_PAGE}`,
      icon: "account-overview",
    },
    {
      text: "Online orders",
      path: `${ENV_VARS.REACT_APP_MY_ACCOUNT_HOST}${routeConstants.ORDERS}`,
      icon: "account-orders",
    },
    {
      text: "Receipts",
      path: `${ENV_VARS.REACT_APP_MY_ACCOUNT_HOST}${routeConstants.STORE_RECEIPTS}`,
      icon: "account-kitchen-sink",
    },
    {
      text: "My details",
      path: `${ENV_VARS.REACT_APP_MY_ACCOUNT_HOST}${routeConstants.MY_DETAILS}`,
      icon: "account-my-details",
    },
    {
      text: loyaltyScheme === MY_PARTNERSHIP ? "My JL My Waitrose" : "My JL",
      path: `${ENV_VARS.REACT_APP_MY_ACCOUNT_HOST}${routeConstants.MY_JL}`,
      icon: loyaltyScheme === "mypartnership" ? "account-my-jl-my-waitrose" : "account-my-jl",
    },
    {
      text: "Wish List",
      path: `${ENV_VARS.REACT_APP_MY_ACCOUNT_HOST}${routeConstants.WISH_LIST_HOME}`,
      icon: "account-wishlist",
    },
    {
      text: "Marketing preferences",
      path: `${ENV_VARS.REACT_APP_MY_ACCOUNT_HOST}${routeConstants.MARKETING_PREFERENCES}`,
      icon: "account-marketing-preferences",
    },
    {
      text: "Appointments",
      path: "/",
      icon: "account-appointments",
    },
    {
      text: "Help",
      path: `${ENV_VARS.REACT_APP_MY_ACCOUNT_HOST}${routeConstants.HELP}`,
      icon: "account-help",
    },
  ].filter((item) => item !== null);

const isActive = (path) => {
  const home = routeConstants.ACCOUNT_OVERVIEW_PAGE;
  const pathName = window.location.pathname;
  return path === pathName || (path.startsWith(routeConstants.MY_JL) && pathName.startsWith(routeConstants.MY_JL)) || (home.startsWith(path) && home.startsWith(pathName));
};

export const Navigation = ({ isHome, breadcrumb, loyaltyScheme }) => (
  <nav className={classNames(styles.nav, { [styles.isHome]: isHome })}>
    {!breadcrumb && (
      <div className={styles.back}>
        <Breadcrumb />
      </div>
    )}
    <div className={styles.forward} data-testid="navForward">
      {getItems(loyaltyScheme).map((item) => (
        <Link
          key={item.path}
          className={classNames(styles.navItem, {
            [styles.navActive]: window.location.href.includes(item.path),
          })}
          data-testid={isActive(item.path) ? "navItemActive" : "navItem"}
          to={item.path}
          isExternal={/^http/.test(item.path)}
        >
          <Icon className={styles.navIcon} name={item.icon} />
          <span className={styles["navItem--copy"]}>{item.text}</span>
        </Link>
      ))}
    </div>
  </nav>
);

Navigation.propTypes = {
  isHome: PropTypes.bool,
  breadcrumb: PropTypes.element,
  loyaltyScheme: PropTypes.string,
};

Navigation.defaultProps = {
  isHome: false,
  breadcrumb: null,
  loyaltyScheme: "none",
};

Navigation.displayName = "Navigation";

export default connect((state) => ({
  loyaltyScheme: property("myjl.account.scheme")(state),
}))(Navigation);
